var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 36,
    viewBox: "0 0 25 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_218_156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 32.1614L18.3786 23.1014C18.3681 23.1067 15.7876 24.3947 15.6695 24.4494C12.7294 25.8974 6.74554 14.0227 9.62 12.4574L12.354 11.0894L7.76932 2L5.00512 3.38534C-4.44777 8.39201 10.5611 38.0281 20.2305 33.5387C20.3894 33.4654 22.9895 32.1667 23 32.1614Z",
    stroke: "#BA71AE",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_218_156"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.e00780e23e185a46e75aa17d4dc86335.svg";
export { ForwardRef as ReactComponent };